import styled from "styled-components";
import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardSearchResult,
  BoardSearchResultTitle,
  BoardTableContainer,
  ChartContainer,
  GraySearchButton,
  SearchButton,
  SubmitContainer
} from "../../assets/GlobalStyles";

/** Shared visual language for report and platform-management pages. */
const UnifiedManagementShell = styled.div`
  --page-accent: #f5811f;
  --page-accent-dark: #d96500;
  --page-accent-soft: #fff6ed;
  --page-text: #2f363d;
  --page-muted: #7e8790;
  --page-line: #e5e8eb;
  --page-surface: #f6f8fa;

  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 14px;
  color: var(--page-text);

  ${Board} {
    overflow: hidden;
    padding: 0;
    border: 1px solid var(--page-line);
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 7px 22px rgba(31, 41, 55, 0.055);
  }

  ${Board} ${Board} {
    margin: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  ${BoardHeader} {
    display: flex;
    min-height: 66px;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid var(--page-line);
    background: linear-gradient(135deg, #fff 0%, #fff8f1 100%);
    color: var(--page-text);
    font-size: 19px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  ${BoardSearchDetail},
  ${BoardSearchResult} {
    margin: 0;
    padding: 20px 24px;
    border: 0;
    background: #fff;
  }

  ${BoardSearchDetail} {
    border-bottom: 1px solid var(--page-line);
    background: var(--page-surface);
  }

  ${BoardSearchDetail} ${BoardSearchDetail} {
    margin: 0 !important;
    padding: 0 !important;
    border: 0;
    background: transparent;
  }

  ${BoardSearchDetail} > div,
  ${BoardSearchDetail} > div > div {
    box-sizing: border-box;
  }

  ${BoardSearchDetail} input:not([type="checkbox"]):not([type="radio"]) {
    height: 40px;
    padding-right: 11px;
    padding-left: 31px;
    background: #fff;
  }

  ${BoardSearchDetail} ${GraySearchButton},
  ${BoardSearchDetail} ${SearchButton} {
    border-color: var(--page-accent);
    background: var(--page-accent);
    color: #fff;
  }

  ${BoardSearchDetail} ${GraySearchButton}:hover:not(:disabled),
  ${BoardSearchDetail} ${SearchButton}:hover:not(:disabled) {
    background: #e87313;
    color: #fff;
  }

  ${BoardSearchResultTitle} {
    min-height: 44px;
    align-items: center;
    padding: 0 0 12px;
    color: var(--page-text);
    font-size: 15px;
    font-weight: 750;
  }

  ${BoardTableContainer} {
    overflow: hidden;
    margin: 0;
    padding: 18px 20px 20px;
    border-top: 1px solid var(--page-line);
    background: #fff;
  }

  ${ChartContainer} {
    min-height: 320px;
    margin: 0;
    padding: 18px 20px 20px;
    border-top: 1px solid var(--page-line);
    background: #fff;
  }

  ${SubmitContainer} {
    display: flex;
    justify-content: flex-end;
    gap: 9px;
    padding: 14px 20px;
    border-top: 1px solid var(--page-line);
    background: #fff;
  }

  input:not([type="checkbox"]):not([type="radio"]),
  textarea,
  select {
    min-height: 40px;
    border: 1px solid #dfe3e6;
    border-radius: 7px;
    background: #fff;
    transition: border-color 140ms ease, box-shadow 140ms ease;
  }

  input:not([type="checkbox"]):not([type="radio"]):focus,
  textarea:focus,
  select:focus {
    border-color: var(--page-accent);
    outline: 0;
    box-shadow: 0 0 0 3px rgba(245, 129, 31, 0.13);
  }

  button {
    border-radius: 7px;
    transition: transform 140ms ease, border-color 140ms ease,
      background-color 140ms ease, box-shadow 140ms ease;
  }

  button:hover:not(:disabled) { transform: translateY(-1px); }
  button:focus-visible {
    outline: 3px solid rgba(245, 129, 31, 0.2);
    outline-offset: 2px;
  }

  .InovuaReactDataGrid,
  .inovua-react-toolkit-table {
    width: 100% !important;
    border: 1px solid var(--page-line) !important;
    border-radius: 9px;
    color: #46505a;
    font-size: 13px;
  }

  .InovuaReactDataGrid__header,
  .InovuaReactDataGrid__column-header {
    background: #fff8f1;
  }

  .InovuaReactDataGrid__column-header {
    border-right-color: #efe2d8;
    color: #4d555d;
    font-size: 12px;
    font-weight: 750;
  }

  .InovuaReactDataGrid__row { border-bottom-color: #edf0f2; }
  .InovuaReactDataGrid__row:hover { background: #fffaf6; }
  .InovuaReactDataGrid__cell { border-right-color: #edf0f2; }

  ${BoardTableContainer} > .InovuaReactDataGrid,
  ${BoardSearchResult} > .InovuaReactDataGrid,
  ${BoardSearchResult} > .inovua-react-toolkit-table {
    box-shadow: none;
  }

  @media (max-width: 760px) {
    ${BoardHeader} { padding: 17px 18px; }
    ${BoardSearchDetail},
    ${BoardSearchResult},
    ${BoardTableContainer},
    ${ChartContainer} { padding-right: 14px; padding-left: 14px; }
  }
`;

export default UnifiedManagementShell;
